//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import Amplify from 'aws-amplify';

import { amplifyConfig } from './config';

Amplify.configure(amplifyConfig);
